"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _AppRenderer2 = _interopRequireDefault(require("../AppRenderer"));

var _translation = _interopRequireDefault(require("../../translation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * BaseHost
 */
var BaseHost = /*#__PURE__*/function (_AppRenderer) {
  _inherits(BaseHost, _AppRenderer);

  var _super = _createSuper(BaseHost);

  /**
   * Constructor
   * @param {Object} initialState - initial state for component
   */
  function BaseHost(initialState) {
    var _this;

    _classCallCheck(this, BaseHost);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this, {}].concat(args));
    var _initialState$appName = initialState.appName,
        appName = _initialState$appName === void 0 ? 'BaseHost' : _initialState$appName,
        _initialState$eventCa = initialState.eventCategory,
        eventCategory = _initialState$eventCa === void 0 ? 'WEB' : _initialState$eventCa;
    _this.appName = appName;
    _this.eventCategory = eventCategory;

    var assetMetadataPromise = _this.fetchAssetMetadata();

    var configurationPromise = _this.fetchConfiguration();

    var imsDataPromise = _this.fetchImsData();

    var themePromise = _this.fetchTheme();

    _this.setState(_objectSpread({
      annotationsEnabled: true,
      annotationsCreationEnabled: false,
      annotationsMultiPageEnabled: true,
      backgroundModeEnabled: false,
      localeStringOverrides: _translation["default"],
      cacheComments: true,
      globalComments: true,
      globalCommentsUnmapped: true,
      isDocumentActive: true,
      onCommentsUpdate: _this.onCommentsUpdate.bind(_assertThisInitialized(_this)),
      onCommentClick: _this.onCommentClick.bind(_assertThisInitialized(_this)),
      onCommentHover: _this.onCommentHover.bind(_assertThisInitialized(_this)),
      onAnnotationToggle: _this.onAnnotationToggle.bind(_assertThisInitialized(_this)),
      onAnnotatingChange: _this.onAnnotatingChange.bind(_assertThisInitialized(_this)),
      onNodeChange: _this.onNodeChange.bind(_assertThisInitialized(_this)),
      onShare: _this.onShare.bind(_assertThisInitialized(_this)),
      isOffline: !navigator.onLine,
      mentionsEnabled: true,
      shareStatus: 'public'
    }, initialState));

    Promise.all([assetMetadataPromise, configurationPromise, imsDataPromise, themePromise]).then(function (values) {
      var _values = _slicedToArray(values, 4),
          assetData = _values[0],
          configuration = _values[1],
          imsData = _values[2],
          theme = _values[3];

      _this.setState(_objectSpread({
        assetData: assetData,
        imsData: imsData,
        theme: theme
      }, _this.buildConfiguration(configuration)));
    });
    _this.onOnlineChange = _this.onOnlineChange.bind(_assertThisInitialized(_this));
    window.addEventListener('online', function () {
      return _this.onOnlineChange(true);
    });
    window.addEventListener('offline', function () {
      return _this.onOnlineChange(false);
    });
    return _this;
  }
  /**
   * Builds and returns analytics data
   * @param {Object} config - configuration object from host
   * @returns {Object} configuration object
   */


  _createClass(BaseHost, [{
    key: "buildConfiguration",
    value: function buildConfiguration() {
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var curState = this.state;

      var _curState$config = _objectSpread(_objectSpread({}, curState), config),
          enableAnalytics = _curState$config.enableAnalytics,
          appVersion = _curState$config.appVersion,
          appId = _curState$config.appId,
          appName = _curState$config.appName,
          osVersion = _curState$config.osVersion,
          platform = _curState$config.platform,
          reviewType = _curState$config.reviewType,
          device = _curState$config.device,
          annotationsEnabled = _curState$config.annotationsEnabled,
          restConfig = _objectWithoutProperties(_curState$config, ["enableAnalytics", "appVersion", "appId", "appName", "osVersion", "platform", "reviewType", "device", "annotationsEnabled"]);

      var analyticsData;
      delete restConfig.analyticsData;

      if (enableAnalytics) {
        analyticsData = {
          event: {
            category: this.eventCategory
          },
          consumer: {
            client_id: appId,
            name: appName || this.appName,
            version: appVersion,
            os_version: osVersion,
            platform: platform
          },
          content: {
            category: reviewType === 'artifact' ? 'Artifact Review' : 'Cloud Doc Review'
          },
          source: {
            platform: platform,
            device: device
          }
        };
      }

      return _objectSpread({
        appId: appId,
        analyticsData: analyticsData,
        reviewType: reviewType,
        annotationsEnabled: annotationsEnabled,
        annotationTypes: {
          pin: annotationsEnabled,
          draw: annotationsEnabled
        },
        device: device,
        platform: platform
      }, restConfig);
    }
    /**
     * Handles online when online state changes.
     * @param {String} isOnline - Current online state
     * @returns {undefined}
     */

  }, {
    key: "onOnlineChange",
    value: function onOnlineChange(isOnline) {
      var _this2 = this;

      var imsData = this.state.imsData;

      var updateState = function updateState(newImsData) {
        _this2.setState({
          isOffline: !isOnline,
          imsData: newImsData
        });
      };

      if (isOnline) {
        this.fetchImsData().then(function (imsResp) {
          return updateState(imsResp);
        });
      } else {
        updateState(imsData);
      }
    }
    /**
     * Returns host API object
     * @returns {Object} hostApi
     */

  }, {
    key: "fetchAssetMetadata",

    /* FETCHERS */

    /**
     * Returns promise for fetching asset metadata
     * @returns {Promise} assetMetadata promise
     */
    value: function fetchAssetMetadata() {
      var assetMetadata = this.mount.getAssetMetadata && this.mount.getAssetMetadata() || {};
      return Promise.resolve(assetMetadata);
    }
    /**
     * Returns promise for fetching configuration
     * @returns {Promise} configuration promise
     */

  }, {
    key: "fetchConfiguration",
    value: function fetchConfiguration() {
      var configuration = this.mount.getConfiguration && this.mount.getConfiguration() || {};
      return Promise.resolve(configuration);
    }
    /**
     * Returns promise for fetching ims data
     * @returns {Promise} imsData promise
     */

  }, {
    key: "fetchImsData",
    value: function fetchImsData() {
      var imsData = this.mount.getIMSData && this.mount.getIMSData() || {};
      return Promise.resolve(imsData);
    }
    /**
     * Returns promise for fetching theme
     * @returns {Promise} theme promise
     */

  }, {
    key: "fetchTheme",
    value: function fetchTheme() {
      var theme = this.mount.getTheme && this.mount.getTheme();
      return Promise.resolve(theme);
    }
    /**
     * Method to handle communication of showComment response success
     * @param {Object} payload - payload object for showComment
     * @returns {undefined}
     */

  }, {
    key: "handleShowCommentResponse",
    value: function handleShowCommentResponse(payload) {
      this.mount.onShowCommentComplete(payload);
    }
    /* METHODS EXPOSED TO HOST */

    /**
     * Updates target object of specified comments.
     * @param {Object} batchUpdateMap - Key value pairs commentId: target object
     * @returns {undefined}
     */

  }, {
    key: "batchCommentUpdate",
    value: function batchCommentUpdate(batchUpdateMap) {
      this.providerRef.current.batchCommentUpdate(batchUpdateMap);
    }
    /**
     * Creates a pending annotation based on host coordinate data
     * @param {Object} payload - host defined annotation data
     * @returns {undefined}
     */

  }, {
    key: "createPendingAnnotation",
    value: function createPendingAnnotation(payload) {
      this.providerRef.current.createPendingAnnotation(payload);
    }
    /**
     * Returns current version of the commenting component
     * @returns {String} The current semver version string of the commenting component
     */

  }, {
    key: "getCommentsVersion",
    value: function getCommentsVersion() {
      return CCX_COMMENTS_VERSION;
    }
    /**
     * Scrolls to and highlights the given comment.
     * @param {Object} commentId - id of comment to highlight to
     * @returns {undefined}
     */

  }, {
    key: "highlightComment",
    value: function highlightComment(commentId) {
      this.providerRef.current.highlightComment(commentId);
    }
    /**
     * Refetches share information from Invitation service
     * @returns {undefined}
     */

  }, {
    key: "reconfigureShareStatus",
    value: function reconfigureShareStatus() {
      this.providerRef.current.reconfigureShareStatus();
    }
    /**
     * Updates node of specified comments.
     * @param {Object} remapObject - Key value pairs commentId: nodeId of which comments and where to map them to.
     * @returns {undefined}
     */

  }, {
    key: "remapComments",
    value: function remapComments(remapObject) {
      this.providerRef.current.remapCommentNodes(remapObject);
    }
    /**
     * Removes a pending annotation
     * @returns {undefined}
     */

  }, {
    key: "removePendingAnnotation",
    value: function removePendingAnnotation() {
      this.providerRef.current.removePendingAnnotation();
    }
    /**
     * Sets asset metadata.
     * @param {Object} assetData - asset data
     * @returns {undefined}
     */

  }, {
    key: "setAssetMetadata",
    value: function setAssetMetadata(assetData) {
      this.setState({
        assetData: assetData
      });
    }
    /**
     * Sets configuration metadata.
     * @param {Object} config - configuration metadata
     * @returns {undefined}
     */

  }, {
    key: "setConfiguration",
    value: function setConfiguration(config) {
      this.setState(_objectSpread({}, this.buildConfiguration(config)));
    }
    /**
     * Updates the commenting panel when the IMS data changes.
     * @param {Object} imsData - ims data object
     * @returns {undefined}
     */

  }, {
    key: "setIMS",
    value: function setIMS(imsData) {
      // TODO: Ensure data format is correct
      this.setState({
        imsData: imsData
      });
    }
    /**
     * Updates the commenting panel when the active theme changes.
     * @param {String} theme - new active theme.
     * @returns {undefined}
     */

  }, {
    key: "setTheme",
    value: function setTheme(theme) {
      this.setState({
        theme: theme
      });
    }
    /**
     * Scrolls to and highlights the given comment.
     * @param {Object} commentId - The id of the comment to scroll to.
     * @returns {undefined}
     */

  }, {
    key: "showComment",
    value: function showComment(commentId) {
      var _this3 = this;

      var handleResponse = function handleResponse(payload, isError) {
        var result;

        if (isError) {
          result = {
            responseType: 'failure',
            message: payload.toString()
          };
        } else {
          result = _objectSpread(_objectSpread({}, payload), {}, {
            responseType: 'success'
          });
        }

        _this3.handleShowCommentResponse(result);
      };

      this.providerRef.current.showComment(commentId).then(function (payload) {
        return handleResponse(payload);
      })["catch"](function (error) {
        return handleResponse(error, true);
      });
    }
    /**
     * Removes highlight from currently highlighted comment.
     * @returns {undefined}
     */

  }, {
    key: "unhighlightComment",
    value: function unhighlightComment() {
      this.providerRef.current.unhighlightComment();
    }
    /* METHODS TO HANDLE COMPONENT EVENTS */

    /**
     * Callback for when annotation visbility is toggled.
     * @param {Boolean} visibility - visbility of annotations.
     * @param {Object} supplementaryData - Other data important to understanding the event
     * @returns {undefined}
     */

  }, {
    key: "onAnnotationToggle",
    value: function onAnnotationToggle(visibility, supplementaryData) {
      this.mount.onAnnotationToggle({
        visibility: visibility,
        supplementaryData: supplementaryData
      });
    }
    /**
     * Callback for when annotating mode changes
     * @param {Object} payload - object containing annotating change data
     * @param {Object} supplementaryData - Other data important to understanding the event
     * @returns {undefined}
     */

  }, {
    key: "onAnnotatingChange",
    value: function onAnnotatingChange(payload, supplementaryData) {
      this.mount.onAnnotatingChange({
        payload: payload,
        supplementaryData: supplementaryData
      });
    }
    /**
     * Callback for when a comment is clicked.
     * @param {Object} commentId - id for clicked comment.
     * @param {Object} supplementaryData - Other data important to understanding the event
     * @returns {undefined}
     */

  }, {
    key: "onCommentClick",
    value: function onCommentClick(commentId, supplementaryData) {
      this.mount.onCommentClick({
        commentId: commentId,
        supplementaryData: supplementaryData
      });
    }
    /**
     * Callback for when a comment is hovered.
     * @param {String} commentId - id for hovered comment.
     * @param {Object} supplementaryData - Other data important to understanding the event
     * @returns {undefined}
     */

  }, {
    key: "onCommentHover",
    value: function onCommentHover(commentId, supplementaryData) {
      var isHovered = supplementaryData.isHovered,
          hasAnnotation = supplementaryData.hasAnnotation;

      if (hasAnnotation) {
        var method = isHovered ? this.mount.onCommentHover : this.mount.onCommentUnhover;
        method({
          commentId: commentId,
          supplementaryData: supplementaryData
        });
      }
    }
    /**
     * Callback for comment updates from the component.
     * @param {Object} commentCounts - Various comment count totals.
     * @param {Object} delta - Comment delta detailing what changed.
     * @param {Object} supplementaryData - Other data important to understanding the event
     * @returns {undefined}
     */

  }, {
    key: "onCommentsUpdate",
    value: function onCommentsUpdate(commentCounts, delta, supplementaryData) {
      this.mount.onCommentsUpdate(_objectSpread(_objectSpread({
        commentCounts: commentCounts
      }, delta), {}, {
        supplementaryData: supplementaryData
      }));
    }
    /**
     * Callback for comment loaded
     * @param {Object} supplementaryData - Other data important to understanding the event
     * @returns {undefined}
     */

  }, {
    key: "onCommentsSuccess",
    value: function onCommentsSuccess(supplementaryData) {
      this.mount.onCommentsSuccess({
        supplementaryData: supplementaryData
      });
    }
    /**
     * Callback for when active node changes.
     * @param {String} nodeId - id of node being being activated.
     * @param {String} sectionId - id of section being being activated.
     * @param {Object} supplementaryData - Other data important to understanding the event
     * @returns {undefined}
     */

  }, {
    key: "onNodeChange",
    value: function onNodeChange(nodeId, sectionId, supplementaryData) {
      this.mount.onNodeChange({
        nodeId: nodeId,
        sectionId: sectionId,
        supplementaryData: supplementaryData
      });
    }
    /**
     * Callback to notify host sharing is being requested.
     * @param {String} reviewType - type of asset review.
     * @param {Object} supplementaryData - Other data important to understanding the event
     * @returns {undefined}
     */

  }, {
    key: "onShare",
    value: function onShare(reviewType, supplementaryData) {
      this.mount.onShare({
        reviewType: reviewType,
        supplementaryData: supplementaryData
      });
    }
  }, {
    key: "mount",
    get: function get() {
      return window.ccxCommentsHostApi;
    }
  }]);

  return BaseHost;
}(_AppRenderer2["default"]);

var _default = BaseHost;
exports["default"] = _default;